import { useOrganizationContext } from '@/context/organization-provider';

export const useOrganizationBranding = () => {
  // Safely try to get organization context, handle when provider is not available
  let organization, isLoading;
  try {
    const context = useOrganizationContext();
    organization = context.organization;
    isLoading = context.isLoading;
  } catch (error) {
    // If OrganizationProvider is not available, use defaults
    console.warn('[useOrganizationBranding] OrganizationProvider not available, using defaults');
    organization = null;
    isLoading = false;
  }

  const getOrganizationName = () => {
    return organization?.display_name || organization?.name || 'Swift Logistics';
  };

  const getOrganizationLogo = () => {
    return organization?.logo_url || '/uploads/d4215903-dca2-4d49-9f0f-47cc0cd1fe09.png';
  };

  const getOrganizationInitial = () => {
    const name = getOrganizationName();
    return name.charAt(0).toUpperCase();
  };

  const getLogoAltText = () => {
    return `${getOrganizationName()} Logo`;
  };

  return {
    organizationName: getOrganizationName(),
    organizationLogo: getOrganizationLogo(),
    organizationInitial: getOrganizationInitial(),
    logoAltText: getLogoAltText(),
    organization,
    isLoading
  };
};